import { Pipe, PipeTransform } from '@angular/core';
//import { IMG_ENDPOINT } from '../../environments/environment';

@Pipe({
  name: 'thumbnail',
})
export class ThumbnailPipe implements PipeTransform {

  transform(src:string, w:string='', h:string='') {
    if (!src) {
      return '';
    }

    let url_obj = new URL(window.location.href);
    if (url_obj['hostname'] == 'localhost' || src.indexOf('?src=') == -1) {
      return src;
    }

    let size = '';
    if (w) {
      size += '&w=' + w;
    }
    if (h) {
      size += '&h=' + h;
    }
    src = src + size;
    //src = IMG_ENDPOINT + '/cache/?src=' + src + size;
    return src;
  }
}


// WEBPACK FOOTER //
// ./src/pipes/thumbnail/thumbnail.ts